import { useGetSubscriptionQuery } from "../app/subscriptionApiSlice";

/**
 * Hook to check if the current school has a pro subscription
 * @returns {boolean} True if subscription plan is "pro", false otherwise
 */
export const useIsPro = () => {
  const { data: subscriptionData, isLoading } = useGetSubscriptionQuery();

  if (isLoading) {
    return false;
  }

  const sub = subscriptionData?.subscription;
  return sub?.plan === "pro" || sub?.billing_mode === "parent_pays";
};
